export default __webpack_public_path__ + "static/media/Degen.c1875efb.png";